/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reference to a partner, which has the role *co-insured person*.   (german: mitversicherte Person)   (bipro-versicherung-haftpflicht::MitversichertePerson)
 */
export interface CoInsuredPerson {
  partnerId: string;
}
